import httpClient from 'api/httpClient';
import { Accountant } from 'models/User';
import { InvestorVerifyForm } from 'router/subrouters/Dash/subrouters/private/subrouters/Profile/pages/ProfilePage/components/InvestorVerify/components/InvestorVerifyFormModal/InvestorVerifyFormModal.component';

function sendForm(values: InvestorVerifyForm) {
  return httpClient.post<Partial<Accountant>>('accountants/send-form', values);
}

function resendForm() {
  return httpClient.post('accountants/resend-form');
}

function getAccountant(token: string) {
  return httpClient.get<Accountant>(`accountants/${token}`);
}

function sendAccountantForm(token: string, values: any) {
  return httpClient.post(`accountants/${token}/submit-form`, values);
}

export default {
  sendForm,
  resendForm,
  getAccountant,
  sendAccountantForm,
};
